import { Zap, CalendarCheck, Sparkles, ShieldCheck, Award, Users } from "lucide-react";

const features = [
  {
    icon: Zap,
    heading: "Fast Online Quotes",
    description: "Get pricing quickly without endless back and forth.",
  },
  {
    icon: CalendarCheck,
    heading: "Reliable Scheduling",
    description: "Choose times that work for you.",
  },
  {
    icon: Sparkles,
    heading: "Professional Equipment",
    description: "Commercial-grade cleaning tools and products.",
  },
  {
    icon: ShieldCheck,
    heading: "Fully Insured Service",
    description: "Complete peace of mind.",
  },
  {
    icon: Award,
    heading: "Satisfaction Guarantee",
    description: "We're not happy unless you're happy.",
  },
  {
    icon: Users,
    heading: "Friendly Local Team",
    description: "Professional and respectful cleaners.",
  },
];

const MovingSimpleSection = () => (
  <section className="bg-[#0066FF] py-16 md:py-24">
    <div className="container">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-3">
          Cleaning Made Simple
        </h2>
        <p className="text-white/80 max-w-xl mx-auto">
          Everything you need from a cleaning company — done properly.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {features.map((f) => (
          <div
            key={f.heading}
            className="bg-white rounded-xl p-6 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(0,0,0,0.15)] transition-all duration-300"
          >
            <div className="w-11 h-11 rounded-lg bg-[#FFD400] flex items-center justify-center mb-4">
              <f.icon className="w-5 h-5 text-[#111111]" strokeWidth={2} />
            </div>
            <h3 className="text-lg font-bold text-[#111111] mb-1.5">
              {f.heading}
            </h3>
            <p className="text-[#111111]/70 text-sm leading-relaxed">
              {f.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <a
          href="#quote"
          className="inline-block bg-[#FFD400] text-[#111111] px-8 py-4 text-lg font-bold rounded-md hover:bg-[#FFD400]/90 transition-colors shadow-[0_4px_14px_rgba(0,0,0,0.2)]"
        >
          Get Free Quote
        </a>
      </div>
    </div>
  </section>
);

export default MovingSimpleSection;
